import { FILTERS_API_URL, SERVER_URL } from "../Consts/config";
import { get } from ".";

const getFilters = async () => await get(`${SERVER_URL}${FILTERS_API_URL}`, {});

export { getFilters };
